import { InfoIconButton } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../state/standardLoanStore';

/** Says why the borrower can't be changed: the loan is linked to a master note, or was created for a B-Client. */
export const BorrowerLinkedNotice = () => {
    const brokerAgreementId = useStandardLoanStore((state) => state.borrower.brokerAgreementId);
    const isSubNote = useStandardLoanStore((state) => state.setupLoanContext.isSubNote);
    const brokerAgreementLocked = useStandardLoanStore((state) => state.borrowerLoanContext.brokerAgreementLocked);

    if (!brokerAgreementId || (!isSubNote && !brokerAgreementLocked)) {
        return null;
    }

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: '6px',
                color: 'darkred',
            }}
        >
            {isSubNote ? 'Linked to Master Note' : 'Linked to B-Client'}
            <InfoIconButton
                modalText={
                    <div>
                        This Loan is linked to {isSubNote ? 'Master Note' : 'a B-Client'}.<br />
                        Broker and Borrower may NOT be changed.
                    </div>
                }
            />
        </div>
    );
};
